import React, {Fragment} from "react";
import {Card, CardContent, Grid, Typography} from "@mui/material"
import {formatPrice} from "~/apps/core/utils";
import moment from "moment";
import {ListIcon} from "~/ui/icons";
import makeStyles from "@mui/styles/makeStyles";


export type ReconciliationProps = {
    balance: {
        openingBalance: number
        closingBalance: number
    }
    documents: {
        date: string
        number: string
        type: string
        amount: number
    }[]
}

const useStyles = makeStyles((theme) => ({
    emptyCardContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        padding: "24px 0 28px"
    },
    listIconContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "80px",
        height: "80px",
        borderRadius: "50%",
        backgroundColor: "rgba(110, 121, 140, 0.07)",
        marginBottom: "16px",

    },
    icon: {
        width: "29px",
        height: "29px",
    },
    subtitle: {
        maxWidth: "269px",
        marginTop: "4px"
    }
}));


export const Reconciliation = (props: ReconciliationProps) => {
    const {balance, documents} = props;
    const classes = useStyles();
    const renderDocuments = (
        <Grid container marginY="-10px">
            {documents.map((doc, index) => (
                <Fragment key={index}>
                    <Grid paddingY="10px" item container direction="row" justifyContent="space-between">
                        <Grid item>
                            <Typography variant="tagsText" color="primary">
                                {doc.type} №{doc.number}
                            </Typography>
                            <br/>
                            <Typography variant="tagsText" color="secondary">
                                {moment(doc.date).format("DD.MM.YYYY")}
                            </Typography>
                        </Grid>
                        <Typography variant="countText" style={{
                            color: {[0]: "rgba(110, 121, 140, 1)", [1]: "rgba(40, 186, 44, 1)", [-1]: "rgba(110, 121, 140, 1)"}[Math.sign(doc.amount)]
                        }}>
                            {formatPrice(doc.amount, {alwaysShowSign: true})}
                        </Typography>
                    </Grid>
                </Fragment>
            ))}
        </Grid>
    );

    const renderEmpty = (
        <Grid container marginY="-10px" className={classes.emptyCardContainer}>
            <div className={classes.listIconContainer}>
                <ListIcon className={classes.icon} />
            </div>
            <Typography variant="cardTitle1" color="secondary">
                Нет данных о сверке
            </Typography>
            <Typography variant="screenSubtitle" color="secondary" className={classes.subtitle}>
                За данный период не было никаких операций
            </Typography>
        </Grid>
    )

    return (
        <Grid container direction="column" spacing="16px">
            <Grid item>
                <Card elevation={4}>
                    <CardContent>
                        <Typography variant="countText" color="black">Остаток</Typography>
                        <Grid container direction="column" rowSpacing="8px" paddingTop="16px">
                            {[
                                {label: "На начало периода", value: balance.openingBalance},
                                {label: "На конец периода", value: balance.closingBalance},
                            ].map(({value, label}, index) => (
                                <Fragment key={index}>
                                    <Grid item container direction="row" justifyContent="space-between">
                                        <Typography variant="cardText" color="secondary">
                                            {label}
                                        </Typography>
                                        <Typography variant="countText" color="primary">
                                            {formatPrice(value)}
                                        </Typography>
                                    </Grid>
                                </Fragment>
                            ))}
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item>
                <Card>
                    <CardContent>
                        {
                            documents.length > 0
                            ? renderDocuments
                            : renderEmpty
                        }
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}
